import providers from "@/lib/api";
import config from "@/config";

export const feedFields = (): string => {
  return config.featureFeedPublicReview
    ? providers.ContentFeedProvider.getFragment("ContentFeed") +
        `... on ContentFeed { reviews { ${providers.ContentFeedProvider.getPageableFragment("Review")}}}`
    : "";
};
